module.exports = __webpack_public_path__ + "static/media/lawnbuddy.471cf954.png";